import * as Sentry from "@sentry/browser";

// Simple Sentry initialization following the docs exactly
Sentry.init({
    dsn: "https://5e11ca2e818d44ef7ca9e2ff129bdf68@o292934.ingest.us.sentry.io/4509826676817920",
    sendDefaultPii: true,
    integrations: [
        Sentry.feedbackIntegration({
            colorScheme: "light",
            showBranding: false,
            buttonLabel: "Feedback",
            formTitle: "Send Feedback",
            submitButtonLabel: "Submit",
            cancelButtonLabel: "Cancel",
        }),
    ],
    debug: import.meta.env.DEV,
    beforeSend(event, hint) {
        // Filter out Alpine.js cancelled transition errors
        if (hint.originalException && 
            typeof hint.originalException === 'object' && 
            hint.originalException.isFromCancelledTransition) {
            console.warn('Filtered out Alpine.js cancelled transition error');
            return null; // Don't send to Sentry
        }
        
        // Filter out unhandled promise rejections with cancelled transitions
        if (event.exception && 
            event.exception.values && 
            event.exception.values.some(exception => 
                exception.type === 'UnhandledRejection' &&
                exception.value && 
                exception.value.includes('isFromCancelledTransition')
            )) {
            console.warn('Filtered out cancelled transition promise rejection');
            return null; // Don't send to Sentry
        }
        
        return event; // Send other errors to Sentry
    }
});

// Export Sentry for use in other parts of the app
window.Sentry = Sentry;

// Helper function to manually trigger feedback widget
window.showFeedbackWidget = function() {
    console.log('Sentry instance:', window.Sentry);
    if (window.Sentry) {
        console.log('Sentry methods:', Object.getOwnPropertyNames(window.Sentry));
    }
};

// Helper function to capture user feedback programmatically
window.captureUserFeedback = function(feedback) {
    if (window.Sentry) {
        return window.Sentry.captureFeedback(feedback);
    } else {
        console.error('Sentry not available');
    }
};

export default Sentry;
